import { render, staticRenderFns } from "./editOwner.vue?vue&type=template&id=18f0873b&scoped=true"
import script from "./editOwner.vue?vue&type=script&lang=js"
export * from "./editOwner.vue?vue&type=script&lang=js"
import style0 from "./editOwner.vue?vue&type=style&index=0&id=18f0873b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0873b",
  null
  
)

export default component.exports